import { axiosInstance } from "../../../axios/axiosInstance";

const API_SUPER_ADMIN_SUBSCRIPTION_URL = "admin/subscription-plan-history";
const API_SUPER_ADMIN_SUBSCRIPTION_LIST_URL = API_SUPER_ADMIN_SUBSCRIPTION_URL + "/list";

export const getSuperAdminSubscription = (dataToBeSent) => {
  return axiosInstance.get(`${API_SUPER_ADMIN_SUBSCRIPTION_LIST_URL}?page=${dataToBeSent?.page || ""}&limit=${dataToBeSent?.limit || ""}${dataToBeSent?.role ? `&role=${dataToBeSent?.role}` : ""}&search=${dataToBeSent?.search || ""}&status=${dataToBeSent?.status || ""}`);
};